export default $axios => (nuxt) => ({
    async postThankYou(orderId, assignmentId, message) {
        let response = await this._updateAssignment(orderId, assignmentId, { thankYou: message });
        return response;
    },

    async getAssignments(orderId) {
        try {
            let response = await $axios.$get(`/api/v1/student/orders/${orderId}/assignments`);

            return response.data;
        } catch (error) {
            nuxt.store.app.$sentry.captureException(error);
            return [];
        }
    },

    async _updateAssignment(orderId, assignmentId, attributes) {
        let response = await $axios.$patch(`/api/v1/student/${orderId}/assignments/${assignmentId}`, { data: {
            type: 'assignment',
            attributes: attributes,
        } });
        return response.data;
    },

    async postSampleEditFeedback(orderId, assignmentId, feedback) {
        let response = await $axios.$post(`/api/v1/student/${orderId}/assignments/${assignmentId}/feedback`, {
            data: {
                type: 'assignment',
                attributes: {
                    'feedback': feedback,
                },
            },
        });
        return response.data;
    },
});
